import React, { useState, useEffect } from "react";
import { sendAppierConversion } from "../tracking/appier";
import { trackButtonClick, parseCurrentUriAds } from "../tracking/tracker";

export const Header = (props) => {
  const [links, setLinks] = useState({
    //line: "https://liff.line.me/2006508428-LaMj0Q6M",
    line: "line://app/2006508428-LaMj0Q6M?_ads=Home_header_line",
    web: "https://play.yhd.tw/?_ads=Home_header_web",
  });

  useEffect(() => {
    const { ads, ref } = parseCurrentUriAds();
    console.log("parseCurrentUriAds:", { ads, ref });

    // 若 ads 或 ref 有其一存在
    if (ads || ref) {
      setLinks((prevLinks) => {
        const updatedLinks = {};

        Object.keys(prevLinks).forEach((key) => {
          try {
            const url = new URL(prevLinks[key]);

            // 用真正的值分別設定 → 不會 double encode
            if (ads) url.searchParams.set("_ads", ads);
            if (ref) url.searchParams.set("ref", ref);

            updatedLinks[key] = url.toString();
          } catch (error) {
            console.error(`Error updating ${key} link:`, error.message);
            updatedLinks[key] = prevLinks[key]; // 保留原始連結
          }
        });

        return updatedLinks;
      });
    }
  }, []); // 空依賴陣列，只在初次渲染時執行

  return (
    <header id="header">
      <div className="intro">
        <div className="container">
          <div className="row">
            <div className="col-md-12 intro-text">
              <a id="btn-header-line" href={links.line} className="btn btn-intro page-scroll" onClick={(e) => {
                sendAppierConversion("Conversion_2484");
                trackButtonClick(e.currentTarget);
              }}
              >
                <img src="img/intro-btn-line.png" className=" " alt="點LINE立即玩" />
              </a>{" "}
              <a id="btn-header-web" href={links.web} className="btn btn-intro page-scroll" onClick={(e) => {
                sendAppierConversion("Conversion_86ab");
                trackButtonClick(e.currentTarget);
              }}
              >
                <img src="img/intro-btn-web.png" className=" " alt="點網頁立即玩" />
              </a>{" "}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};